import {Injectable} from '@angular/core';
import {Message} from '../../../operating-standard/chat/message.model';
import {UserService} from '../../../../services/user.service';
import * as moment from 'moment';
import {ReviewSuggestionListsService} from './review-suggestion-lists.service';
import {SuggestionListsService} from './suggestion-lists.service';
import {HttpResponse} from '@angular/common/http';
import 'rxjs/add/operator/do';

const CHAT_DATE_FORMAT = 'DD.MM.YYYY HH:mm:ss';
const MESSAGE_OK = 200;
const MESSAGE_CREATED = 201;

@Injectable()
export class ChatSuggestionListsService {

  // чаты от стандарта тут будут храниться
  private slChatMessages: Message[] = [];

  constructor(private userService: UserService,
              public reviewSuggestionListsService: ReviewSuggestionListsService,
              public suggestionListsService: SuggestionListsService) {
  }

  // Добавить сообщение в локальный лист
  addMessage(message: string) {
    const currentUser = this.userService.getLocal();
    const newMsg = new Message(currentUser.id, currentUser.fullName, message, moment().format(CHAT_DATE_FORMAT));

    return this.suggestionListsService.addMessageToChat(newMsg).do(
      (res: HttpResponse<Message>) => {
        if ((res.status === MESSAGE_OK || res.status === MESSAGE_CREATED) && res.body) {
          this.slChatMessages.unshift(res.body);
        }
      }
    );
  }

  getMessages() {
    return this.suggestionListsService.getSLChatMessages();
  }

  getTempMsg() {
    return this.slChatMessages;
  }

  clearMessages() {
    this.slChatMessages = [];
  }

  setMessages(messages) {
    this.slChatMessages = messages;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/services/chat-suggestion-lists.service.ts